import { render } from "./Color.vue?vue&type=template&id=4d3dd1d7&scoped=true"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"

import "./Color.vue?vue&type=style&index=0&id=4d3dd1d7&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3dd1d7"]])

export default __exports__